import { UTM_FIELDS } from './constants';

/**
 * Get referral cookie
 *
 * @returns {string[]} referral cookie values
 */
const getReferralCookie = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split('; referral_sources=');
  let parsed = '';
  if (parts.length === 2) {
    parsed = parts.pop().split(';').shift();
  }
  // eval is OK here
  // eslint-disable-next-line no-eval
  return parsed.length > 0 ? eval(decodeURIComponent(parsed)) : [];
};

const buildQueryParamObj = () => {
  const queryString = window.location.toString().split('?')[1];
  let queryObj = {
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_term: null,
    utm_content: null,
    gclid: null,
    msclkid: null,
    mbsy: null,
    irgwc: null,
    irclickid: null,
    campaign_id: null,
  };

  if (queryString) {
    const queryArr = queryString.split('&');
    queryObj = queryArr.reduce((innerQueryObj, el) => {
      const [key, value] = el.split('=');
      // eslint-disable-next-line no-param-reassign
      innerQueryObj[key] = value;
      return innerQueryObj;
    }, {});
  }
  return Object.keys(queryObj).length === 0 ? null : queryObj;
};

const getCurrentReferralSource = () => {
  const queryObj = buildQueryParamObj();
  const hasUtmParams = queryObj
    ? Object.keys(queryObj).some(k => UTM_FIELDS.includes(k))
    : false;

  const hasExternalReferrer =
    !document.referrer.includes('fundera') && document.referrer.length > 0;

  let referralSource;
  if (hasExternalReferrer || hasUtmParams) {
    referralSource = {
      params: {
        utm_source: queryObj.utm_source,
        utm_medium: queryObj.utm_medium,
        utm_campaign: queryObj.utm_campaign,
        utm_term: queryObj.utm_term,
        utm_content: queryObj.utm_content,
        gclid: queryObj.gclid,
        msclkid: queryObj.msclkid,
        mbsy: queryObj.mbsy,
        irgwc: queryObj.irgwc,
        irclickid: queryObj.irclickid,
        new_campaign_id: queryObj.campaign_id,
      },
      referrer: document.referrer.length > 0 ? document.referrer : null,
      path: window.location.pathname,
      from_blog: true,
      blog_landing_page: `https://www.fundera.com${window.location.pathname}`,
      referred_at: new Date().toISOString(),
    };
  }
  return referralSource;
};

const setReferralSources = () => {
  const currentReferralSource = getCurrentReferralSource();
  const existingReferralSources = getReferralCookie();
  if (currentReferralSource) {
    existingReferralSources.push(currentReferralSource);
  }
  const stringified = encodeURIComponent(
    JSON.stringify(existingReferralSources)
  );
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 120);
  document.cookie = `referral_sources=${stringified};path=/;expires=${d.toGMTString()}`;
};

export { setReferralSources };
export default setReferralSources;
